import SectionHeader from '@components/ui/SectionHeader'
import styles from './styles.module.scss'

export default function PageHeader({ title }: { title: string }) {
  return (
    <div className={styles.PageHeader}>
      <SectionHeader title={title} variant="left_aligned" />
    </div>
  )
}
